import React, { useState } from 'react';
import { SaveIcon, PlusIcon } from 'lucide-react';
interface User {
  id: string;
  name: string;
  role: string;
  company: string;
  tags: string[];
  goals: string;
  image: string;
}
interface ProfileScreenProps {
  user: User;
  setUser: React.Dispatch<React.SetStateAction<User>>;
}
export function ProfileScreen({
  user,
  setUser
}: ProfileScreenProps) {
  const [formData, setFormData] = useState({
    ...user
  });
  const [newTag, setNewTag] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const addTag = () => {
    if (newTag.trim() && !formData.tags.includes(newTag.trim())) {
      setFormData(prev => ({
        ...prev,
        tags: [...prev.tags, newTag.trim()]
      }));
      setNewTag('');
    }
  };
  const removeTag = (tagToRemove: string) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter(tag => tag !== tagToRemove)
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setUser(formData);
    // In a real app, you would save to backend here
  };
  return <div className="flex flex-col flex-1" data-id="element-173">
      <header className="p-4 flex items-center justify-between border-b" data-id="element-174">
        <h1 className="text-xl font-bold text-gray-800" data-id="element-175">Your Profile</h1>
        <button className="bg-indigo-600 text-white px-3 py-1 rounded-md flex items-center gap-1 text-sm" onClick={handleSubmit} data-id="element-176">
          <SaveIcon size={16} data-id="element-177" />
          Save
        </button>
      </header>
      <div className="flex-1 p-4 overflow-y-auto" data-id="element-178">
        <form className="space-y-6" onSubmit={handleSubmit} data-id="element-179">
          <div className="flex items-center gap-4" data-id="element-180">
            <img src={formData.image} alt={formData.name} className="w-20 h-20 rounded-full object-cover border-2 border-indigo-600" data-id="element-181" />
            <button className="text-indigo-600 text-sm font-medium" data-id="element-182">
              Change Photo
            </button>
          </div>
          <div data-id="element-183">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-184">
              Full Name
            </label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md" data-id="element-185" />
          </div>
          <div data-id="element-186">
            <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-187">
              Role
            </label>
            <input type="text" id="role" name="role" value={formData.role} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md" data-id="element-188" />
          </div>
          <div data-id="element-189">
            <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-190">
              Company
            </label>
            <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md" data-id="element-191" />
          </div>
          <div data-id="element-192">
            <label htmlFor="tags" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-193">
              Interest Tags
            </label>
            <div className="flex flex-wrap gap-2 mb-2" data-id="element-194">
              {formData.tags.map((tag, index) => <span key={index} className="bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full text-sm flex items-center" data-id="element-195">
                  {tag}
                  <button type="button" className="ml-1 text-indigo-600 hover:text-indigo-800" onClick={() => removeTag(tag)} data-id="element-196">
                    ×
                  </button>
                </span>)}
            </div>
            <div className="flex" data-id="element-197">
              <input type="text" id="newTag" value={newTag} onChange={e => setNewTag(e.target.value)} placeholder="Add a tag" className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md" data-id="element-198" />
              <button type="button" onClick={addTag} className="bg-indigo-600 text-white px-3 py-2 rounded-r-md" data-id="element-199">
                <PlusIcon size={18} data-id="element-200" />
              </button>
            </div>
          </div>
          <div data-id="element-201">
            <label htmlFor="goals" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-202">
              Your Goals
            </label>
            <textarea id="goals" name="goals" value={formData.goals} onChange={handleChange} rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="What are you looking for at this event?" data-id="element-203"></textarea>
          </div>
        </form>
      </div>
    </div>;
}